function setupReviewFilter () {

  function setTabActive() {

    $('#reviews-tabs > li').each(function () {

      if ($(this).attr('data-is-selected') === "true") {
        $($(this).children('span').css('color','black'));
        $($(this).children('div').css('background','#005D95'));

        const tab = $(this).attr('data-target');

        $('.jc-tabs-content-reviews > div').each(function () {

          if (tab === $(this).attr('id')) {
            $(this).removeClass('d-none');

            if((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
              $(this).addClass('d-flex');
            }

            $('.slick-slider').slick('refresh');

          } else {

            if((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
              $(this).removeClass('d-flex');
            }

            $(this).addClass('d-none');
          }

        });

      } else {
        $($(this).children('span').css('color','#A0AEC0'));
        $($(this).children('div').css('background','#A0AEC0'));
      }

    });

  }

  setTabActive();

  $('#mais-vistos-tab, #mais-recentes-tab, #visto-ultimo-tab').on('click', function (e) {

    const target = $(this).attr('id');

    if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {

      if (target === 'mais-vistos-tab') {
        $('#jc-review-seen-slider-buttons').removeClass('d-none');
        $('#jc-review-seen-slider-buttons').addClass('d-lg-flex');

        $('#jc-review-recent-slider-buttons').removeClass('d-lg-flex');
        $('#jc-review-recent-slider-buttons').addClass('d-none');

        $('#jc-latest-seen-slider-buttons').removeClass('d-lg-flex');
        $('#jc-latest-seen-slider-buttons').addClass('d-none');

      } else if(target === 'mais-recentes-tab'){
        $('#jc-review-recent-slider-buttons').removeClass('d-none');
        $('#jc-review-recent-slider-buttons').addClass('d-lg-flex');

        $('#jc-review-seen-slider-buttons').removeClass('d-lg-flex');
        $('#jc-review-seen-slider-buttons').addClass('d-none');

        $('#jc-latest-seen-slider-buttons').removeClass('d-lg-flex');
        $('#jc-latest-seen-slider-buttons').addClass('d-none');
      }
      else {
        $('#jc-review-seen-slider-buttons').removeClass('d-lg-flex');
        $('#jc-review-seen-slider-buttons').addClass('d-none');

        $('#jc-review-recent-slider-buttons').removeClass('d-lg-flex');
        $('#jc-review-recent-slider-buttons').addClass('d-none');

        $('#jc-latest-seen-slider-buttons').removeClass('d-none');
        $('#jc-latest-seen-slider-buttons').addClass('d-lg-flex');
      }
    }

    $(this).attr('data-is-selected', 'true');

    $('#reviews-tabs > li').each(function () {

      if (target !== $(this).attr('id')){
        $(this).attr('data-is-selected', 'false');
      }

    });

    setTabActive();

  });

}

$(document).ready(function () {
  setupReviewFilter();
});
